export const UPDATE_PHONE_SEARCH = "UPDATE_PHONE_SEARCH"

export type UpdatePhoneSearchAction = {
  type: typeof UPDATE_PHONE_SEARCH
  active: boolean
}
